import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderRec from '../../../header/headerRec';
import axios from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Paper, Tabs, Tab, Typography, TextField, Divider, Card, Avatar, CardContent, FormControl, Select, MenuItem } from '@mui/material';
import CustomAlert from '../../../commun/CustomAlert';
import MissionInfo from './MissionInfo';
import ProfilRecherche from './ProfilRecherche';
import ComplementaireInfos from './ComplementaireInfos';
import CvViewer from './CvViewer';
import NotesTab from './NotesTab';
import HistoriqueTab from './HistoriqueTab';
import ProfilAnonymise from './ProfilAnonymise';
import Footer from '../../../commun/Footer';
import TalentInsightsCard from './TalentInsightsCard';
import PresentationModal from './PresentationModal';
import LoadingPage from '../../../commun/LoadingPopup';
import './detailTalent.css';
import { Stack } from '@mui/system';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Chatbox from '../../../commun/ChatBox';
import MissionCard from '../../../commun/MissionCard';
import { statusOptions, statusOptionsRecruteur } from '../../../commun/constants/options';


const DetailTalent = ({ talentId: propTalentId, isModal = false, onUpdate = () => {} }) => {
const [modalOpen, setModalOpen] = useState(false);
const [selectedTalent, setSelectedTalent] = useState(null);

const handleFieldChange = (field, value) => {
  setEditableTalent(prev => ({
    ...prev,
    [field]: value,
  }));
};

const handleClose = () => setModalOpen(false);
  const navigate = useNavigate();
  const { talentId: paramTalentId } = useParams();
  const talentId = propTalentId || paramTalentId;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [talent, setTalent] = useState(null);
  const location = useLocation();
  const formData = location.state?.plainFormData;
  const [editableTalent, setEditableTalent] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userType");
  const [isEditing, setIsEditing] = useState(false);

  const isValidValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
      const cleaned = value.trim().replace(/^"|"$/g, '');
      return cleaned !== '' && cleaned.toLowerCase() !== 'null' && cleaned !== '[]';
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === 'object') {
      return Object.keys(value).length > 0;
    }
    return true;
  };

useEffect(() => {
  const fetchTalent = async () => {
    try {
      if (!authToken) {
        setAlertMessage("Session expirée. Veuillez vous reconnecter.");
        setAlertSeverity("error");
        setAlertOpen(true);
        navigate("/login");
        return;
      }

      let res;
      try {
        res = await axios.get(`${API_BASE}/api/recruteur/talent/${talentId}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          res = await axios.get(`${API_BASE}/api/admin/candidat/${talentId}`, {
            headers: { Authorization: `Bearer ${authToken}` }
          });
        } else {
          throw error;
        }
      }

      const fetchedData = res.data;
      const safeFormData = formData || {};

      const mergedData = Object.keys(fetchedData).reduce((acc, key) => {
        const formValue = safeFormData[key];
        let parsedFormValue = formValue;
        try {
          if (
            typeof formValue === "string" &&
            (formValue.startsWith("[") || formValue.startsWith("{"))
          ) {
            parsedFormValue = JSON.parse(formValue);
          }
        } catch {
          parsedFormValue = formValue;
        }
        acc[key] = isValidValue(parsedFormValue)
          ? parsedFormValue
          : fetchedData[key];
        return acc;
      }, {});

      mergedData.cvUpload = fetchedData.cvUpload;
      mergedData.statut = fetchedData.statut;

      setTalent(fetchedData);
      setEditableTalent(mergedData);
    } catch (err) {
      console.error("Erreur lors du chargement du talent :", err);

if (err.response?.status === 403) {
  navigate("/access-denied");
  return;
}
 else if (err.response?.status === 404) {
        setAlertMessage("Talent introuvable.");
        setAlertSeverity("warning");
        setAlertOpen(true);
        navigate("/dashboard");
      } else if (err.response?.status === 401) {
        setAlertMessage("Session expirée. Veuillez vous reconnecter.");
        setAlertSeverity("error");
        setAlertOpen(true);
        navigate("/login");
      } else {
        setAlertMessage("Erreur lors du chargement du talent.");
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    }
  };

  fetchTalent();
}, [talentId, API_BASE]);



const [hasAnonymisedCV, setHasAnonymisedCV] = useState(false);

useEffect(() => {
  const checkCv = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/cv-generated/exists/${talentId}`, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      setHasAnonymisedCV(res.data.exists);
    } catch (err) {
      console.error('Erreur vérification CV anonymisé', err);
      setHasAnonymisedCV(false);
    }
  };

  if (talentId && authToken) checkCv();
}, [talentId]);



  const handleChange = (_, newValue) => setActiveTab(newValue);

  const saveTalentData = async () => {
    try {
      const fullName = localStorage.getItem("recruteurName");
      const updatedTalent = {
        ...editableTalent,
        recruteurName: fullName,
        langues: typeof editableTalent.langues === 'string' ? JSON.parse(editableTalent.langues) : editableTalent.langues,
        competences: typeof editableTalent.competences === 'string' ? JSON.parse(editableTalent.competences) : editableTalent.competences,
      };

      const payload = Object.fromEntries(
        Object.entries(updatedTalent).filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            !(typeof value === 'string' && value.trim() === '') &&
            !(Array.isArray(value) && value.length === 0) &&
            JSON.stringify(value) !== JSON.stringify(talent[key])
        )
      );

      payload.userId = localStorage.getItem("userId");

      if (!Object.keys(payload).length) {
        setAlertMessage("Aucune modification détectée.");
        setAlertSeverity("info");
        setAlertOpen(true);
        return;
      }

      
      const isCandidat = talent.origine === 'Candidat';
      const updateUrl = isCandidat
        ? `${API_BASE}/api/admin/edit-candidat-st/${talentId}`
        : `${API_BASE}/api/recruteur/update-talent/${talentId}`;

await axios.put(updateUrl, payload, {
  headers: {
    Authorization: `Bearer ${authToken}`
  }
});

      const fetchUrl = isCandidat
        ? `${API_BASE}/api/admin/candidat/${talentId}`
        : `${API_BASE}/api/recruteur/talent/${talentId}`;

const res = await axios.get(fetchUrl, {
  headers: {
    Authorization: `Bearer ${authToken}`
  }
});
      setTalent(res.data);
      setEditableTalent(res.data);
      onUpdate(res.data);
      setAlertMessage("Données mises à jour !");
      setAlertSeverity("success");
      setAlertOpen(true);
    } catch (err) {
      console.error("Erreur mise à jour:", err);
      setAlertMessage("Erreur lors de la mise à jour");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };


if (!talent) {
  return <LoadingPage open={true} message="Chargement du profil talent..." />;
}


  const otherstatusOptions = 
  (userRole === 'admin' || userRole === 'commercial'|| userRole === 'agent') 
    ? statusOptions
    : statusOptionsRecruteur;

    const getStatusColorClass = (statut) => {
      if (!statut) return 'status-color-default';
    
      const normalized = statut.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
      if (normalized === 'a traiter') return 'status-color-a-traiter';
      if (normalized === 'qualifie attente controle') return 'status-color-qualifie-attente-controle';
      if (normalized.includes('recrute')) return 'status-color-recrute';
    
      return 'status-color-default';
    };
    
  return (
      <div className="entreprise-page">
          {!isModal && (
            <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
          )}
          <Paper elevation={3} className="tab-container">
               <Tabs
                 value={activeTab}
                 onChange={handleChange}
                 variant="scrollable"
                 scrollButtons="auto"
                 textColor="primary"
                 indicatorColor="primary"
                 TabIndicatorProps={{ sx: { height: 3, borderRadius: 2 } }}
               >
                 <Tab label="Talent" />
                 <Tab label="Formation et Compétences" />
                 <Tab label="Infos complémentaires" />
                 <Tab label="CV Talent" />
                 {userRole !== 'agent' && <Tab label="Profil Anonymisé" />}
                 <Tab label="Historique" />
                 <Tab label="Notes" />
               </Tabs>
          </Paper>
          <main className="pageContainer">
            <div className="contentWrapper">
            <div className="contentGrid">
            {/* ✅ Colonne de gauche */}
            <aside className="leftColumn">
            <div className="contactCardContainer">
             <Card className="contact-card-modern">
               <CardContent>
               <div className="contact-avatar-container">
                 <Stack direction="column" spacing={1} alignItems="center">
                   <Avatar className="contact-avatar-img">{editableTalent?.trigramme?.substring(0, 3).toUpperCase() || 'T'}</Avatar>
                   <Typography variant="h6">
                     {editableTalent?.nomCandidat} {editableTalent?.prenomCandidat}
                   </Typography>
                 </Stack>
                 </div>
                 <Divider sx={{ my: 1 }} />
                 <Typography variant="body2">
                   <EmailIcon fontSize="small" /> 
                   {(Array.isArray(editableTalent?.email) ? editableTalent.email : [editableTalent?.email])
                    .filter(Boolean)
                    .join(' , ')}
                 </Typography>
                 <Typography variant="body2">
                   <PhoneIcon fontSize="small" />{' '}
                    {(Array.isArray(editableTalent?.phone) ? editableTalent.phone : [editableTalent?.phone])
                      .filter(Boolean)
                      .join(', ')}
                 </Typography>
               </CardContent>
             </Card>
             <TalentInsightsCard
              talent={editableTalent}
              hasAnonymisedProfile={hasAnonymisedCV}
              onPresentClick={() => {
                setSelectedTalent(editableTalent);
                setModalOpen(true);
              }}
            />
            </div>
            </aside>
            {/* ✅ Colonne principale */}
            <section className="mainColumn">  
              <div className="missionContent">
                {activeTab === 0 && (
                <MissionInfo {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange , isEditing, setIsEditing}} />
                )}
                {activeTab === 1 && (
                  <ProfilRecherche {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange }} />
                )}
                {activeTab === 2 && (
                  <ComplementaireInfos {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange }} />
                )}
                {activeTab === 3 && (
                  <CvViewer {...{ talent, apiBase: API_BASE, editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData }} />
                )}
                {activeTab === 4 && <ProfilAnonymise talent={talent} apiBase={API_BASE} />}
                {activeTab === 5 && <HistoriqueTab historique={talent?.historique} />}
                {activeTab === 6 && <NotesTab talentId={editableTalent?._id} origine={editableTalent?.origine} />}      
              </div>
            </section>
            <aside className="sideColumn">
            <div className="talent-card">
                  <Stack className="mission-info-header">
                    {isEditing && editableTalent?.statut !== 'Recruté' ? (
                      <FormControl sx={{ width: 200 }} margin="normal">
                        <Select
                          labelId="statut-label"
                          value={editableTalent?.statut || ''}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            handleFieldChange('statut', newValue);
                          }}                        >
                          <MenuItem value="" disabled>
                            -- Sélectionnez un statut --
                          </MenuItem>
                          {otherstatusOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                    <div className={`status-badge ${getStatusColorClass(editableTalent?.statut)}`}>
                      {
                        statusOptionsRecruteur.find((opt) => opt.value === editableTalent?.statut)?.label ||
                        editableTalent?.statut ||
                        'Non défini'
                      }
                    </div>                                       
                    )}
                  </Stack>

                </div> 
                           <MissionCard
              missions={[
                { nom: 'Refonte du portail client', poste: 'Développeur Full Stack' },
                { nom: 'Migration cloud Azure', description: 'Mission DevOps de 6 mois' }
              ]}
            />

             <PresentationModal
               open={modalOpen}
               onClose={handleClose}
               talent={selectedTalent}
               apiBase={API_BASE}
             />
            </aside>
            </div>
            </div>
          </main>
            <Chatbox userRole="recruteur" />
            {!isModal && <Footer />}
            <CustomAlert open={alertOpen} message={alertMessage} severity={alertSeverity} onClose={() => setAlertOpen(false)} />
      </div>
  );
};

export default DetailTalent;
